import { Link } from "react-router-dom";
import { Gift } from "lucide-react";

export default function GiftCardPromo() {
  return (
    <section className="py-16 px-5" data-testid="gift-card-promo">
      <div className="max-w-4xl mx-auto">
        <div className="bg-[#1a1a1a] rounded-3xl p-8 sm:p-12 flex flex-col sm:flex-row items-center gap-8">
          <div className="w-20 h-20 rounded-2xl bg-amber-500/15 flex items-center justify-center shrink-0">
            <Gift size={36} className="text-amber-400" />
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h2 className="font-display font-black text-2xl sm:text-3xl text-white">Give the gift of pizza</h2>
            <p className="text-white/50 font-medium mt-2 max-w-md">Digital gift cards from ₹500 to ₹5,000. Redeemable online and at the counter. Crafted with 72 hours of patience.</p>
          </div>
          <Link to="/gift-cards" data-testid="gift-card-promo-cta" className="bg-amber-500 text-white font-bold px-8 py-4 rounded-full text-sm hover:bg-amber-600 transition-colors shrink-0 whitespace-nowrap">
            Buy a Gift Card
          </Link>
        </div>
      </div>
    </section>
  );
}
